import Base from './base'
import Pager from '../components/Pager'

class Articles extends Base {
  constructor(page) {
    super(page)

    this.list = this.page.querySelector('.articles')
  }

  init = () => {
    super.init()
    this.initPager()
  }

  initPager = () => {
    const list = this.page.querySelector('.articles-wrapper')
    const listInner = list.querySelector('.articles')
    this.pager = new Pager(list, listInner, '.article', '.next-link')
    this.pager.init()
  }
}

export default Articles
